import type { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid';

/**
 * Community DataGrid forces `checkboxSelectionVisibleOnly: false`, so header
 * select-all selects every filtered row. Clamp that to the current page while
 * preserving selections made on other pages.
 */
export function clampSelectionToPage(
  model: GridRowSelectionModel,
  previous: GridRowSelectionModel,
  pageIds: readonly GridRowId[],
): GridRowSelectionModel {
  const pageSet = new Set(pageIds);
  const previousOffPage = previous.type === 'include' ? [...previous.ids].filter((id) => !pageSet.has(id)) : [];

  if (model.type === 'exclude') {
    return { type: 'include', ids: new Set<GridRowId>([...previousOffPage, ...pageIds]) };
  }

  const selectedOnPage = pageIds.filter((id) => model.ids.has(id));
  const selectedOffPageInModel = [...model.ids].filter((id) => !pageSet.has(id));
  const isCommunitySelectAll = selectedOnPage.length === pageIds.length && pageIds.length > 0 && selectedOffPageInModel.length > 0;

  const pageSelection = isCommunitySelectAll ? [...pageIds] : selectedOnPage;
  return { type: 'include', ids: new Set<GridRowId>([...previousOffPage, ...pageSelection]) };
}
